import React from 'react'
import styles from './styles.css'
import MdInfoOutline from 'react-icons/lib/md/info-outline'
import Button from 'orionsoft-parts/lib/components/Button'

export default class Instructions extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.section}>
        <div className={styles.instructions}>
          <div className="row">
            <h2 className="col-xs-12 col-sm-2">Instrucciones:</h2>
            <div className="col-xs-12 col-sm-10" style={{textAlign: 'right', paddingRight: 28}}>
              <MdInfoOutline size={30} />
            </div>
          </div>
          <ol>
            <li>
             Subir los documentos que desea enviar masivamente a firmar.
            </li>
            <div className={styles.imageContainer}>
              <img
                className={styles.image}
                src="/instructionsmassiveupload1.png"
                alt="instruction 1"
              />
            </div>
            <li>
              Descargar la plantilla Excel base presionando en el botón
              DESCARGAR MODELO.
            </li>
            <div className={styles.view}>
              <Button primary>Descargar Modelo</Button>
            </div>
            
            <li>
              Completar los campos del archivo excel, respetando el orden de la
              plantilla y NO modificar la primera columna ( columna A ).
            </li>
            <div className={styles.imageContainer}>
              <img
                className={styles.image}
                src="/instructionsmassiveupload2.png"
                alt="instruction 2"
              />
            </div>
            <li>
              Opcionalmente, es posible añadir nombre del documento
              (remplazará el nombre original) y tags (puede ser más de 1
              separados por comas).
            </li>
            <div className={styles.imageContainer}>
              <img
                className={styles.image}
                src="/instructionsmassiveupload3.png"
                alt="instruction 3"
              />
            </div>
            <li>
                Una vez que el archivo excel se ha terminado, guarda los cambios, y
                sube el documento arrastrando el archivo al recuadro Upload
                file bajo el campo &quot;Excel&quot;, o haciendo click en él. Una vez subida la
                planilla el botón Cargar Documentos se colocará Azul y podrá hacer
                click para enviar los documentos a firmar.
                <br/>* Las firmas utilizadas en este proceso no se pueden recuperar
                <br/>** En caso de existir errores la plataforma informará bajo el botón
                Cargar Documentos una vez realizado en envío si existiese alguno.
            </li>
            <div className={styles.imageContainer}>
              <img
                className={styles.image}
                src="/instructionsmassiveupload4.png"
                alt="instruction 4"
              />
            </div>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/MassiveDactilar/Instructions/index.js